<template>
  <div id="website" ref="scroll">
    <div class="logo">
      <img :src="logoImg" alt="" />
    </div>
    <nav-menu v-if="!isFromWechat" @click="handleClick"></nav-menu>
    <popup :visible="visible" @close="closeDrawer"></popup>
    <div id="top-img">
      <swiper class="address-swiper" :options="swiperOption">
        <swiper-slide>
          <div class="swiper-item-wrapper">
            <div class="address-item">
              <i class="iconfont icon-position positioning-icon" />
              <div>
                <h3 class="address-item-title">BEIJING</h3>
                <h3 class="address-item-title">英特波科技(北京)有限公司</h3>
                <!-- <p class="address-item-desc">
                  北京市朝阳区建国路93号院1号楼1808室
                </p> -->
                <p class="address-item-desc">
                  北京市朝阳区光华路4号东方梅地亚中心C座2801
                </p>
              </div>
            </div>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="address-item">
            <i class="iconfont icon-position positioning-icon" />
            <div>
              <h3 class="address-item-title">SHENZHEN</h3>
              <h3 class="address-item-title">英特波科技(深圳)有限公司</h3>
              <p class="address-item-desc">
                深圳市南山区粤海街道大冲社区深南大道9668号华润置地大厦C座2708
              </p>
            </div>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="address-item">
            <i class="iconfont icon-position positioning-icon" />
            <div>
              <h3 class="address-item-title">SHANGHAI</h3>
              <h3 class="address-item-title">上海办公室</h3>
              <p class="address-item-desc">
                上海市长宁区古北路666号嘉麒大厦22楼01室
              </p>
              <p class="address-item-desc">
                上海市长宁区凯旋路1398号3号楼1005室
              </p>
            </div>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="address-item">
            <i class="iconfont icon-position positioning-icon" />
            <div>
              <h3 class="address-item-title">CHENGDU</h3>
              <h3 class="address-item-title">成都办公室</h3>
              <p class="address-item-desc">
                成都市锦江区红星路三段1号国际金融中心IFS 1号办公楼30楼02号
              </p>
            </div>
          </div>
        </swiper-slide>
      </swiper>
    </div>
    <video
      id="myvideo"
      width="100%"
      height="auto"
      controls="controls"
      muted="muted"
      autoplay
      loop
    >
      <source src="../../assets/video/background.mp4" type="video/mp4" />
    </video>
    <div class="choose-btn" @click="showArea = true">
      <pre style="margin-bottom: 0">{{ selectedAreaText }}</pre>
    </div>
    <van-popup v-model="showArea" position="bottom">
      <van-area
        title="选择省市区"
        :value="selectedAreaCodes"
        :columns-placeholder="['请选择', '请选择', '请选择']"
        :area-list="areaList"
        @confirm="onConfirm"
        @cancel="showArea = false"
      />
    </van-popup>
    <van-search
      :clearable="false"
      class="search-wrapper"
      left-icon="none"
      right-icon="search"
      v-model="searchValue"
      @change="onchange"
      placeholder="请输入店铺名称"
    />
    <div
      class="item-wrapper"
      v-for="item in storeList"
      :key="item.F_EnCode"
      @click="() => handleOpenDetail(item)"
    >
      <div class="item-logo" style="position: relative">
        <img :src="normalizeAssetUrl(item.F_Logo)" alt="图片获取失败" />
        <img v-if="item.F_hasProMAX==='1'" src="../../assets/img/black-vip.png" style="position: absolute;left:-4px;top:-2px;width:60%" alt=""/>
        <div v-if="item.F_hasProMAX==='1'" style="position: absolute;left:2px;top:-1px;width:60%;font-size: 9px;">黑金用户</div>
      </div>
      <div class="item-descrption">
        <h3>{{ item.F_FullName }}</h3>
        <p>{{ item.provinceName + item.cityName + item.countryName }}</p>
        <div class="icon-name">
          <div>
            <p>{{ item.F_Address | capitalize }}</p>
          </div>
          <div class="icon-des">
            <img
              width="12px"
              height="12px"
              src="../../assets/store-detail/next.png"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
    <van-empty v-show="!storeList.length" description="暂无数据" />
  </div>
</template>

<script>
let vm;
import NavMenu from "./components/NavMenu.vue";
import Popup from "./components/Popup.vue";
import areaList from "../pc/config/areaList";
import { throttle } from "lodash";
import BScroll from "@better-scroll/core";
import Pullup from "@better-scroll/pull-up";
import axios from "axios";
import "vue-awesome-swiper/node_modules/swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { normalizeAssetUrl as normalizeLogoUrl } from "../../utils/asset-url";
BScroll.use(Pullup);
// BScroll.use(Pullup);
export default {
  name: "Founds",
  components: {
    Popup,
    NavMenu,
    swiper,
    swiperSlide,
  },
  created() {
    vm = this;
    document.title = "找到INDIBA";
    const queryObj = this.$route.query;
    if (queryObj && queryObj.formWechat) {
      console.log("isFromwechat", this.isFromWechat);
      this.isFromWechat = true;
    }
    // 从 URL 参数恢复选择状态
    const query = this.$route.query;
    if(query.provinceId){
      this.selectedAreaCodes = [query.provinceId, '', ''];
    }
    if(query.provinceId && query.cityId){
      this.selectedAreaCodes = [query.provinceId, query.cityId, ''];
    }
    if (query.provinceId && query.cityId && query.countyId) {
      this.selectedAreaCodes = [query.provinceId, query.cityId, query.countyId];
    }
    this.currentPage = 1;
    this.onSearch();
  },
  mounted() {
    this.initMouseScroll();
    document
      .getElementById("myvideo")
      .setAttribute("controlslist", "nodownload"); 
  },
  data() {
    return {
      selectedAreaCodes: [],
      values: undefined,
      visible: false,
      logoImg: require("../../assets/home/logo.png"),
      showArea: false,
      btnTitle: "点我选择省市区",
      areaList,
      searchValue: "",
      currentPage: 1,
      //isFromWechat: false,
      //   totalNum: 0,
      storeList: [],
      swiperOption: {
        slidesPerView: 1.3,
      },
      getPopupContainers: (triggerNode) => triggerNode.parentNode,
      storeName: "",
    };
  },
  filters: {
    capitalize: function (value) {
      //   return value.slice(0, 14);
      return value;
    },
  },
  watch: {

  },
  computed:{
    selectedAreaText() {
          if (!this.selectedAreaCodes[0]) return '点我选择省市区';
          
          let text = '';
          if (this.selectedAreaCodes[0]) {
            text += this.areaList.province_list[this.selectedAreaCodes[0]];
          }
          if (this.selectedAreaCodes[1]) {
            text += ' ' + this.areaList.city_list[this.selectedAreaCodes[1]];
          }
          if (this.selectedAreaCodes[2]) {
            text += ' ' + this.areaList.county_list[this.selectedAreaCodes[2]];
          }
          
          return text;
        },  
  },
  methods: {
    normalizeAssetUrl(url) {
      return normalizeLogoUrl(url);
    },
    // handleNavMap(){

    // },
    // 初始化监听滚动
    initMouseScroll() {
      // const listBox = document.getElementById("website");
      // console.log("listBox",listBox);
      const handleScroll = async () => {
        const scrollTop =
          document.documentElement.scrollTop || document.body.scrollTop;
        // 可视区高度
        const clientHeight =
          document.documentElement.clientHeight || document.body.clientHeight;
        // 滚动条总高度
        const scrollHeight =
          document.documentElement.scrollHeight || document.body.scrollHeight;

        if (scrollHeight - scrollTop - clientHeight <= 1) {
          // console.log("滚动到底部了");
          //以及滚到底部了
          this.isPullUpLoad = true;
          this.isLoading = true;
          this.currentPage += 1;
          await this.onSearch();
          this.isPullUpLoad = false;
          this.isLoading = false;
        }
      };
      // 滚动节流
      const throttleHandleScroll = throttle(handleScroll, 1000);

      document.addEventListener("scroll", throttleHandleScroll);
    },
    initBscroll() {
      this.scroll = new BScroll(this.$refs.scroll, {
        probeType: 3,
        pullUpLoad: true,
      });

      this.scroll.on("pullingUp", () => this.pullingUpHandler());
    },
    async pullingUpHandler() {
      // console.log("滚动到底部了");
      this.isPullUpLoad = true;
      this.isLoading = true;
      this.currentPage += 1;
      await this.onchange();
      this.isPullUpLoad = false;
      this.isLoading = false;
    },
    handleMapNav(F_Longitude, F_Latitude, F_Address, F_FullName) {
      const params = { F_Longitude, F_Latitude, F_Address, F_FullName };
      // console.log("params",params)
      this.$router.push({
        path: "/map",
        query: params,
      });
    },
    handleClick() {
      this.visible = true;
    },
    handleOpenDetail(params) {
      const { F_CompanyId } = params;
      console.log("F_CompanyId", F_CompanyId);
      this.$router.push({
        path: "/storeDetails",
        query: { F_CompanyId, formWechat: this.isFromWechat },
      });
    },
    closeDrawer() {
      this.visible = false;
    },
    onConfirm(values) {
      console.log("val:", values);
      this.values = values;
      this.btnTitle = values.filter((item) => !!item).map((item) => item.name);
      this.currentPage = 1;

      // 更新URL参数
      const query = {};
      if (values[0] && values[0]?.code) query.provinceId = values[0]?.code;
      if (values[1]&& values[1]?.code) query.cityId = values[1]?.code;
      if (values[2]&& values[2]?.code) query.countyId = values[2]?.code;
      this.selectedAreaCodes = [query.provinceId, query.cityId, query.countyId];
      this.$router.replace({
        name: "Found",
        query: Object.keys(query).length ? query : undefined,
      });
      this.onSearch();
      vm.storeList = [];
      this.currentPage=1;
      this.showArea = false;
    },
    onSearch() {
    let queryURL = ``
    if(this.selectedAreaCodes[0]){
      queryURL = `&provinceId=${this.selectedAreaCodes[0]}`;
    }
    if(this.selectedAreaCodes[0] &&this.selectedAreaCodes[1] ){
      queryURL = `&provinceId=${this.selectedAreaCodes[0]}&cityId=${this.selectedAreaCodes[1]}`;
    }
    if(this.selectedAreaCodes[0] && this.selectedAreaCodes[1] && this.selectedAreaCodes[2]){
      queryURL = `&provinceId=${this.selectedAreaCodes[0]}&cityId=${this.selectedAreaCodes[1]}&countyId=${this.selectedAreaCodes[2]}`;
    }
    if(this.searchValue){
      queryURL += `&companyName=${this.searchValue}`
    }

      axios
        .get(`/api/Company/GetMyPageList?rows=20&page=${this.currentPage}${queryURL}`)
        .then(function (res) {
          let tempList = res.data.data.rows;
          tempList.forEach((item) => {
            item.provinceName = "";
            item.cityName = "";
            item.countryName = "";
            for (let i in areaList.province_list) {
              if (item.F_ProvinceId === i) {
                item.provinceName = areaList.province_list[i] || "";
              }
            }
            for (let i in areaList.city_list) {
              if (item.F_CityId === i) {
                item.cityName = areaList.city_list[i] || "";
              }
            }
            for (let i in areaList.county_list) {
              if (item.F_CountyId === i) {
                item.countryName = areaList.county_list[i] || "";
              }
            }
          });
          vm.storeList.push(...tempList);
        })
        .catch(function (err) {
          this.$message.error(err);
        });
    },
    onchange(e) {
      console.log("e", e);
      this.currentPage = 1;
      vm.storeList = [];
      this.searchValue = e.target._value;
      this.onSearch();
    },
  },

};
</script>

<style lang="less" scoped>
#website {
  background-color: #001a70;
  width: 100vw;
  min-height: 100vh;
  overflow: hidden;
  color: #fff;
  .logo {
    width: 200px;
    height: 34px;
    left: 1.5rem;
    top: 1.8rem;
    z-index: 1;
    position: absolute;
  }
  #top-img {
    width: 100vw;
    height: 300px;
    background-image: url(../../assets/img/bgc2.png);
    background-size: 100% 100%;
    background-repeat: no-repeat;
    position: relative;
    .address-swiper {
      .address-item {
        margin-top: 120px;
        background: rgba(0, 0, 0, 0.2);
        height: 120px;
        color: #f0f0f0 !important;
        padding: 0 0.8rem;
        margin-right: 0.8rem;
        margin-left: 0.8rem;
        border-radius: 10px;
        display: flex;
        align-items: center;
        .positioning-icon {
          margin-right: 0.3rem;
        }
        .address-item-title {
          font-size: 0.9rem;
          font-weight: 500;
          color: #f0f0f0 !important;
          height: 1rem;
          line-height: 1.125rem;
        }
        .address-item-desc {
          font-size: 0.4rem;
          color: rgba(0, 0, 0, 0.65);
          line-height: 1rem;
          color: #f0f0f0 !important;
        }
        .address-item-desc:first-child {
          margin-top: 0.8rem;
        }
      }
    }
  }
  .choose-btn {
    text-align: center;
    padding: 0.5rem 0;
    margin: 1rem;
    border: 1px solid #fff;
    background-color: transparent;
    border-radius: 5px;
    font-size: 0.8rem;
    color: #fff;
  }
  .search-wrapper {
    margin: 0 1rem;
    background-color: #001a70;
    .van-search__content {
      color: #fff !important;
      padding-left: 0;
      border-bottom: 1px solid #999;
      background-color: #001a70;
      //   input.van-field__control::-webkit-input-placeholder{
      //     color: #fff!important;
      //   }
    }
    .van-search__content /deep/.van-field__control {
      color: #fff !important;
    }
  }
  .item-wrapper {
    margin: 1rem;
    display: flex;
    align-items: center;
    justify-content: space-around;
    .item-logo {
      width: 5rem;
      height: 5rem;
      background-color: #fff;
      display: flex;
      border-radius: 5px;
      align-items: center;
      justify-content: center;
      img {
        width: 90%;
        max-height: 100%;
      }
    }
    .item-descrption {
      width: 14rem;
      margin: 0;
      margin-left: 1rem;
      padding: 0.5rem;
      font-size: 0.7rem;
      background-color: #6b8ac8;
      border-radius: 5px;
      h3 {
        font-size: 0.9rem !important;
        color: #fff;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      p {
        margin-top: 0.1rem;
        margin-bottom: 0.1rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        a {
          color: #fff;
        }
      }
      .icon-name {
        display: flex;
        justify-content: space-between;
      }
      p {
        width: 12rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    .item-icon {
      //   font-size: 1rem;
      margin-right: 0.2rem;
    }
    .icon-des {
      display: flex;
      // border-left: 1px solid #fff;
      width: 1rem;
      justify-content: space-around;
      align-items: flex-end;
      flex-direction: column;
    }
  }
}
</style>
